import React from 'react';
import { ButtonProps } from '~/components/button';

import * as S from './SubmitButton.styled';

export interface SubmitButtonProps extends ButtonProps {}

export const SubmitButton: React.FC<SubmitButtonProps> = ({ ...props }) => <S.Button {...props} />;
